/**
* Maintained by Qinlili
*/
<template>
  <cascade-selector
    v-bind="{...$props, ...$attrs}"
    :height="height"
    :width="width"
    :fixHeight="fixHeight"
    :placeholder="placeholder"
    :data="data"
    :selectedKeys="selected"
    :multiple="IsMultiple"
    :props="defaultProps"
    :selectedTagsMaxHeight="140"
    :disabled="disabled"
    @change="change"
    @checkbox-click="checkboxClick"
    @unselect-node-tag="unselectTag">
  </cascade-selector>
</template>

<script>
  import api from './api.js'
  import GetData from '../../../utils/response'
  import { componentMessage } from '../utils'
  import CascadeSelector from '../../basis/cascade-selector/index.js'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'region-cascade-selector',
    components: {
      CascadeSelector
    },
    props: {
      // 是否需要全国
      wholeCountry: {
        type: Boolean,
        default: false
      },
      // 是否需要全选
      selectAll: {
        type: Boolean,
        default: false
      },
      // 固定高度
      fixHeight: {
        type: Boolean,
        default: true
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 第一次回填
      selectedKeys: {
        type: Array,
        default: () => []
      },
      // 设定宽度
      width: {
        type: String,
        default: '340'
      },
      // 设定高度
      height: {
        type: String,
        default: '38'
      },
      IsMultiple: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: pageText.pleaseSelectDistrict
      }
    },
    created () {
      let flag = this.componentMessage(['purchaser', 'supplier'], 'region-tree-cascade')
      if (flag) return
      let regionData = this.getItem('regionData')
      if (regionData) {
        this.data = JSON.parse(regionData)
        this.hasWholeCountry()
        this.hasSelectAll()
      } else {
        this.getData()
      }
    },
    watch: {
      selectedKeys: {
        immediate: true,
        handler (data, oldData) {
          if (!data) {
            return
          }
          this.$nextTick(() => {
            this.selected = data
          })
        }
      }
    },
    data () {
      return {
        pageText,
        componentMessage,
        data: [],
        selected: [],
        defaultProps: {
          key: 'id',
          label: 'name',
          children: 'childList'
        },
        defaultOptions: {
          id: '00',
          name: pageText.theNational,
          childList: []
        },
        selectAllptions: {
          id: '000',
          name: pageText.selectAll,
          childList: [],
          parent: {
            id: '000',
            name: null
          }
        },
        currentSelectAll: false,
        simpleLength: 0
      }
    },
    methods: {
      getItem (key) {
        return window.localStorage.getItem(key)
      },
      setItem (key, value) {
        window.localStorage.setItem(key, value)
      },
      hasWholeCountry () {
        if (this.wholeCountry) {
          this.data.unshift(this.defaultOptions)
        }
      },
      // 添加全选
      hasSelectAll () {
        if (this.selectAll) {
          this.data.unshift(this.selectAllptions)
        }
      },
      async getData () {
        let apis = api[window.fe.project].getCityTree
        const data = await GetData(this.$http(apis.type, apis.url))
        if (data.isOk) {
          data.content.forEach((ele, index) => {
            let obj = {
              id: ele.cityCode,
              name: ele.name,
              parent: {
                id: null,
                name: null
              },
              childList: []
            }
            ele.children.forEach((item) => {
              obj.childList.push({
                id: item.cityCode,
                name: item.name,
                parent: {
                  id: ele.cityCode,
                  name: ele.name
                },
                childList: []
              })
            })
            this.data.push(obj)
          })
          this.setItem('regionData', JSON.stringify(this.data))
          this.hasWholeCountry()
          this.hasSelectAll()
        }
      },
      change (dataArr) {
        if (!this.selectAll) {
          this.$emit('updateArea', dataArr.simple, this.data)
          return false
        }
        let currentSelectAll = dataArr.simple[0].id === '000'
        if (currentSelectAll) {
          if (dataArr.simple.length === 1) {
            this.updateSelectAll()
            this.$emit('updateArea', this.data)
            this.simpleLength = this.data.length
            return
          } else {
            if (!this.selected.includes('000')) {
              this.updateSelectAll()
              this.$emit('updateArea', this.data)
              this.simpleLength = this.data.length
            } else {
              this.selected = []
              dataArr.simple.shift()
              this.$emit('updateArea', dataArr.simple, this.data)
              this.simpleLength = dataArr.simple.length
            }
            return
          }
        }

        console.log(dataArr.simple.length, this.simpleLength, this.data.length, 888)
        if (dataArr.simple.length === 0) {
          return
        }

        if (dataArr.simple.length === this.data.length - 1) {
          if (this.simpleLength >= dataArr.simple.length) {
            this.selected = []
            this.$emit('updateArea', [])
          } else {
            this.updateSelectAll()
            this.$emit('updateArea', this.data)
          }
          this.simpleLength = dataArr.simple.length
        } else {
          this.$emit('updateArea', dataArr.simple, this.data)
        }
      },
      checkboxClick (item) {
        // 单击全部清空其他选中全部
        if (item.key === '00') {
          if (item.checked && this.selectedKeys.length === 1) {
            this.selected = []
            return
          }
          setTimeout(() => {
            this.$emit('updateArea', [this.defaultOptions])
          })
        }
      },
      unselectTag (item) {
        if (item.key === '00') {
          if (!item.checked && this.selectedKeys.length === 1) {
            this.selected = []
            return
          }
          setTimeout(() => {
            this.$emit('updateArea', [this.defaultOptions])
          })
        }
      },
      updateSelectAll () {
        this.selected.push('000')
        for (let i = 0; i < this.data.length; i++) {
          let ele = this.data[i]
          if (ele.parent && ele.parent.id) {
            this.selected.push(ele.parent.id)
          }
          if (ele.childList.length) {
            ele.childList.forEach((item) => {
              this.selected.push(item.id)
            })
          }
        }
        this.selectAllLength = this.selected.length
      }
    }
  }
</script>

<style scoped>

</style>
